<template>
  <h1>Page Not Found</h1>
</template>

<script>
export default {
  name: "Page Not Found",
};
</script>
<style>
</style>